import React, { JSX, useRef } from 'react';
import { css } from '@emotion/react';
import { useDimensions } from '@anytag/shared-hooks';

export interface ChartsContainerProps {
  className?: string;
  elements: (JSX.Element | null | undefined)[];
}

export const ChartsContainer = ({ className, elements = [] }: ChartsContainerProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { width } = useDimensions(containerRef);

  const chartWidth = width ? (width - 16 * 6) / (elements.length || 1) : undefined;
  const validElements = elements.filter((el): el is JSX.Element => el !== null);

  return (
    <div css={{ display: 'flex' }} ref={containerRef} className={className}>
      {validElements.map((el, index) => (
        <div key={index} css={styles.item}>
          {React.cloneElement(el, { ...el.props, width: chartWidth })}
        </div>
      ))}
    </div>
  );
};
const styles = {
  item: css({
    flex: '1 1 0',
    overflow: 'hidden',
    borderRight: '1px solid #e6ecf0',
    '&:last-of-type': { borderRightStyle: 'none' }
  })
};
